

import React from 'react';
import './videotree.css';

const VideoTree = ({ videos, onVideoSelect, selectedVideo, onMarkComplete, progress }) => {

    const isSelectedVideoCompleted = progress && selectedVideo && progress[selectedVideo.id]?.completed;

    return (
        <div className='setting-tree mx-4 px-3'>
            <ul className='list-unstyled px-4'>
                <li className='d-flex justify-content-center my-4'>Módulo 1 | {videos?.length} clases</li>
                {
                    videos && videos.length > 0 ? (
                        videos.map((video, index) => {
                            const isCompleted = progress && progress[video.id]?.completed;
                            return (
                                <li 
                                    key={video.id} 
                                    className={`d-flex flex-column py-3 video-tree-item ${selectedVideo?.id === video.id ? 'active-video' : ''}`}
                                    onClick={() => onVideoSelect(video)}
                                >
                                    <div className="d-flex align-items-center">
                                        {isCompleted ? (
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="17" height="17" className="me-2">
                                                <path
                                                    fill="var(--yellow-green)"
                                                    d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z" />
                                            </svg>
                                        ) : (
                                            <div className="video-progress-circle me-2"></div>
                                        )}
                                        <span>Clase {index + 1}</span>
                                    </div>
                                    <h5>{video.title}</h5>
                                </li>
                            )
                        })
                    ) : (
                        <li className='d-flex justify-content-center py-3'>No hay videos disponibles</li>
                    )
                }
                <button className="btn btn-primary w-100 my-3" onClick={onMarkComplete}>
                    {isSelectedVideoCompleted ? 'Marcar como no completado' : 'Completar Lección'}
                </button>
            </ul>
        </div>
    );
}

export default VideoTree;
